import React, { useState, useEffect } from "react";
import l from "components/util/l";

const SortForm = ({ 
  columns, 
  sorting = [],
  updateSorting = () => {},
  onClose = () => {}
}) => {

  const [sortingValues, setSortingValues] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const _onClickChangeSorting = (conditions) =>
    updateSorting(conditions);

  useEffect(() => {
    if(!loaded) {
      setSortingValues(sorting);
      setLoaded(true);
    }
  }, [sorting]);

  return (
    <div className="card card-body">

      <div className="d-flex justify-content-between align-items-center w-100 mb-2">
        <h3>{l("Ordenar por%CA147")}</h3>
        <div className="d-flex mt-2">
          <button 
            className="btn btn-sm btn-outline-primary"
            onClick={() => {
              setSortingValues([...sortingValues, { name: null, order: "ASC" }]);
            }}
          >
            <i className="fas fa-plus mr-1"></i>
            {l("Agregar campo%CA146")}
          </button>
        </div>
      </div>

      {
        sortingValues.map((sortingValue, index) => (
          <div 
            key={`sorting-${index}`}
            className="d-flex justify-content-between align-items-center w-100 mb-2"
          >
            <div className="d-flex w-100">
              <select
                className="form-control form-control-sm mr-2 w-100"
                value={sortingValue.name}
                onChange={(e) => {
                  const newSortingValues = [...sortingValues];
                  newSortingValues[index].name = e.target.value;
                  setSortingValues(newSortingValues);
                }}
              >
                {
                  columns.map((column, index) => (
                    <option key={index} value={column.name}>{column.label}</option>
                  ))
                }
              </select>
              <select
                className="form-control form-control-sm mr-2"
                value={sortingValue.order}
                onChange={(e) => {
                  const newSortingValues = [...sortingValues];
                  newSortingValues[index].order = e.target.value;
                  setSortingValues(newSortingValues);
                }}
              >
                <option value="ASC">{l("Ascendente%CA148")}</option>
                <option value="DESC">{l("Descendente%CA149")}</option>
              </select>
            </div>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => {
                const newSortingValues = [...sortingValues];
                newSortingValues.splice(index, 1);
                setSortingValues(newSortingValues);
              }}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ))
      }

    <div className="d-flex justify-content-end align-items-center w-100 mt-3">
      <button
        className="btn btn-primary mr-3"
        onClick={() => {
          _onClickChangeSorting(sortingValues);
          onClose();
        }}
      >
        {l("Aplicar%GA086")}
      </button>
      <button 
        className="btn btn-outline-danger"
        onClick={() => {
          _onClickChangeSorting([]);
          onClose();
        }}
      >
        {l("Limpiar%GA087")}
      </button>
    </div>

    </div>
  );

}

export default SortForm;